import React from "react"
import { Button } from "reactstrap"
import { X } from "react-feather"

export default function CloseButton({ onClick, className = "p-0 text-muted" }){
  return (
    <Button color="link" onClick={onClick} className={className}>
      <X />
    </Button>
  )
}